<ng-container *ngIf="costTypeDistributionState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ data.id ? ('app.dialog.cost-type-distribution.title-update.header' | translate: {costTypeName: state.selectedCostType.name})
        : ('app.dialog.cost-type-distribution.title-create.header' | translate: {costTypeName: state.selectedCostType.name})}}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input
            [fields]="data.id ? state.editFields : state.addFields"
            [(inputFormGroup)]="formGroup"
            [initialValue]="data">
        </mat-generic-input>
    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="!dialogFieldsValid" mat-flat-button color="primary" (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
